import {gql, useMutation} from "@apollo/client";

const ADD_TEAM_TO_GROUP_MUTATION = gql`
mutation addTeamToGroup($stageId: Int!, $seasonId: Int!, $groups: [GroupTeamStructure]!) {
  addTeamToGroup(stageId: $stageId, seasonId: $seasonId, groups:$groups) {
    group{
        id
    }
  }
}
`;

export default function AddTeamToGroupMutation() {
    return useMutation(ADD_TEAM_TO_GROUP_MUTATION);
}